import axios from "../axios";
import { Cookies } from 'react-cookie'
const endPoint = `/cart/`

const cookie = new Cookies()

const token = await cookie.get('user')

export const addCart = async (product_id, color, size, dressing,quantity) => {
    console.log("color",color);
    
    return await axios.post(`${endPoint}`, {
        product_id: product_id,
        quantity,
        color: color,
        size: size,
        dressing: dressing,
    }, { headers: { authorization: token } })
}

export const get_cart = async () => {
    return (await (await axios.get(`${endPoint}`, { headers: { 'Authorization': token } })).data.response)
}

export const increse_item = async (_id) => {
    return await axios.put(`${endPoint}plus/${_id}`, {}, { headers: { authorization: token } })
}
export const decrease_item = async (_id) => {
    return await axios.put(`${endPoint}minus/${_id}`, {}, { headers: { authorization: token } })
}

export const Delete_cart_item = async (_id) => {
    return await axios.delete(`${endPoint}${_id}`, { headers: { authorization: token } })
}